import React, { PureComponent } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { CDialog } from "@appcues/component-library";
import { navigate as navigateAction } from "actions/routing";

const INSTALL_PATH = "/settings/installation";

export class InstallModalTestMode extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      hideModal: PropTypes.func.isRequired
    }).isRequired,
    navigate: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.onClickInstallNow = this.onClickInstallNow.bind(this);
  }

  onClickInstallNow() {
    const { actions, navigate } = this.props;
    navigate(INSTALL_PATH);
    actions.hideModal();
  }

  render() {
    const { actions } = this.props;

    return (
      <CDialog
        title="Install to test flows!"
        primaryActionText="Install Now"
        onPrimaryAction={this.onClickInstallNow}
        secondaryActionText="Install Later"
        onSecondaryAction={actions.hideModal}
      >
        <Text>Unlock the power of Appcues by installing it.</Text>
        <Text>
          Once you're installed, you can test flows, share flows with your
          teammates, and publish to our users!
        </Text>
      </CDialog>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  navigate: bindActionCreators(navigateAction, dispatch)
});

export default connect(null, mapDispatchToProps)(InstallModalTestMode);

const Text = styled.p`
  line-height: 26px;
`;
